import React from 'react'
import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {
    FlexGrowContent,
    FullWidthColumnFlexContainer,
    RowFlexContainer
} from '../../../../styledComponents/FlexComponents'
import {Close} from '@mui/icons-material'
import {getFileExtension} from '../../../common/util/Natutil'
import {Colors, FontFamily, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import styled from 'styled-components'
import {currentMedia, HideInPC} from '../../../../styledComponents/ResponsiveConvenience'
import {StyledLink} from '../../../../styledComponents/residentPage/Links'
import {
    getLinkIconComponent,
    DialogCloseButton,
    DisplayItemDividerDialog,
    DialogTitleArea,
    MainArea,
    PanelArea,
} from '../common/NatResidentAssocWorkReportsCommon'

interface Props {
    onClose: () => void
    businessName: string
    resultFiles: {
        fileNumber: number
        publishMaterialName: string
        fileSizeKB: string
        path: string
    }[]
}

export const NatResidentReportFileListDialog: React.FC<Props> = props => {
    const {
        businessName,
        resultFiles
    } = props

    return (<>
        <PanelArea>
            <DialogTitleArea>
                <RowFlexContainer>
                    <StyleDialogTitle>{businessName}</StyleDialogTitle>
                    <DialogCloseButton onClick={props.onClose} id={'close'}>
                        <Close fontSize={'large'} style={{color: `${Colors.AccentDark}`}}/>
                    </DialogCloseButton>
                </RowFlexContainer>
            </DialogTitleArea>
            <DisplayItemDividerDialog/>
            <MainArea>
                <HideInPC>
                    <Box height={'15px'}/>
                    <StyleCaution>
                        ※ファイルサイズが大きい場合は、Wi-Fi環境下での閲覧を推奨します。
                    </StyleCaution>
                </HideInPC>
                <Box height={'20px'}/>
                {resultFiles.map((resultFile, index) => {
                    const fileSizeKB = Number(resultFile.fileSizeKB)

                    const resultFileSizeText = fileSizeKB >= 1024
                        ? `${Math.round(fileSizeKB / 1024)}MB`
                        : `${fileSizeKB}KB`

                    return <AttachmentFileList key={`resultFile-${index}`}>
                                <LinkButton to={resultFile.path}>
                                    <StyledFileContainer>
                                        <HideInPC>
                                            <AttachmentFileIconStyle>
                                                {getLinkIconComponent(
                                                    getFileExtension(resultFile.publishMaterialName)
                                                )}
                                            </AttachmentFileIconStyle>
                                        </HideInPC>
                                        <StyledFileNameContainer>
                                            <StyledFileName>
                                                {resultFile.publishMaterialName}
                                            </StyledFileName>
                                            <HideInPC>
                                                <Box fontSize={FontSize.Small} color={Colors.AccentDark}>
                                                    {resultFileSizeText}
                                                </Box>
                                            </HideInPC>
                                        </StyledFileNameContainer>
                                    </StyledFileContainer>
                                </LinkButton>
                            </AttachmentFileList>
                })}
            </MainArea>
            <FlexGrowContent/>
        </PanelArea>
    </>)
}

const StyleDialogTitle = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
  line-height: 30px;
  margin: 7px 0 7px 5px;
  ${currentMedia.lessThan('sp')`
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
  `};
`

const StyledFileName = styled.div`
  width: 100%;
  font-size: ${FontSize.Body};
  color: ${Colors.Primary};
  line-height: 24px;
  text-align: left;
  ${currentMedia.lessThan('sp')`
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     color: ${Colors.Body};
  `};
`

const AttachmentFileList = styled.div`
  padding-bottom: 10px;
  ${currentMedia.lessThan('sp')`
     padding-bottom: 5px;
  `};
`

const AttachmentFileIconStyle = styled.div`
  font-size: 21px;
  line-height: 1;
  min-width: 21px;
  text-align: center;
  margin-right: 10px;
  color: ${Colors.AccentDark};
`

const StyleCaution = styled.div`
  font-size: ${FontSize.Small};
  color: ${Colors.Body};
  line-height: 18px;
`

const StyledFileContainer = styled(RowFlexContainer)`
  width: 100%;
  font-family: ${FontFamily.ResidentDefault};
  ${currentMedia.lessThan('sp')`
     overflow: hidden;
     padding: 0px 10px;
     border: 1px solid ${Colors.AccentLight};
     border-radius: 4px;
  `};
`
const StyledFileNameContainer = styled(FullWidthColumnFlexContainer)`
  align-items: flex-start;
  ${currentMedia.lessThan('sp')`
     padding: 10px 0 10px 0;
     overflow: hidden;
     color: ${Colors.Body};
  `};
`
const LinkButton = withStyles({
    root: {
        width: '100%',
    }
})(StyledLink)
